import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  Survey = 'Survey',
  Results = 'Results',
  Overview = 'Overview',
  Print = 'Print',
}

export const queryKeys = {
  survey: (clientId?: number) => [QueryFeature.BeFi20, QueryKey.Survey, clientId],
  results: (clientId: number, compareToId?: string) => [
    QueryFeature.BeFi20,
    QueryKey.Results,
    clientId,
    compareToId,
  ],
  overview: (clientId: number) => [QueryFeature.BeFi20, QueryKey.Overview, clientId],
  print: (clientId: number, compareIds: string[] | null) => [
    QueryFeature.BeFi20,
    QueryKey.Print,
    clientId,
    compareIds,
  ],
};
